import { motion } from "framer-motion";

const items = [
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/jc09fdie_Frame%202147225850.jpg",
    caption: "Conference floor",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/f4rv2zni_IMG_7288.mp4",
    caption: "Behind the scenes",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/j1vbr3dw_Frame%202147225852.jpg",
    caption: "Community meetup",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/299eilfr_IMG_8878.mp4",
    caption: "On the move",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/dhqew0nw_Hacker6.jpg",
    caption: "On stage — speaking on product",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/hn04a6xn_x-downloader.com_giVy13.mp4",
    caption: "More behind the scenes",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/a4ncg2pm_PHOTO-2025-11-10-10-50-52.jpg",
    caption: "Africa Blockchain Festival",
  },
];

export default function PersonalInterests() {
  return (
    <section
      data-testid="personal-interests-section"
      className="bg-white py-24 sm:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          data-testid="personal-interests-text"
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-light leading-snug tracking-tight text-zinc-900"
        >
          Outside of work, I enjoy{" "}
          <span className="font-medium">running</span>,{" "}
          <span className="font-medium">mentoring new designers</span>, and{" "}
          <span className="font-medium">exploring AI in product systems</span>.
        </motion.p>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 mt-14 sm:mt-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              data-testid={`personal-media-${i}`}
              className="group relative aspect-[4/5] rounded-2xl overflow-hidden bg-zinc-100 ring-1 ring-zinc-200/60"
            >
              {item.type === "image" ? (
                <img
                  src={item.src}
                  alt={item.caption}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              ) : (
                <video
                  src={item.src}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <p className="absolute bottom-3 left-3 right-3 text-xs sm:text-sm text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                {item.caption}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
